import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { ClassroomCourseComponent, CourseWrapperComponent } from './pages';
import { ClassroomParticipantsComponent } from './pages/classroom-participants/classroom-participants.component';
import { ClassroomCourseResolver } from './store/services/classroom-course.resolver';
import { CountryResolver } from "@shared/resolvers/country.resolver";

const routes: Route[] = [
  {
    path: '',
    component: CourseWrapperComponent,
    resolve: { countries: CountryResolver },
    children: [
      {
        path: 'participants',
        component: ClassroomParticipantsComponent,
        resolve: [ClassroomCourseResolver],
        pathMatch: 'full'
      },
      {
        path: ':id',
        component: ClassroomCourseComponent,
        resolve: [ClassroomCourseResolver],
      },

    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClassroomRoutingModule {}
